module.exports = __webpack_public_path__ + "img/img_live_hover.92f32181.svg";